import React, { FC, ReactElement } from 'react';

import styles from './styles.module.scss';

import { TooltipProps } from 'recharts';
import { FormatUtils } from '../../../../../../../../../../../../utils';

export const CustomTooltip: FC<TooltipProps<number, string>> = ({
    payload,
}: TooltipProps<number, string>): ReactElement => {
    const { createdAt, proposals } = payload?.[0]?.payload || {};

    return (
        <div className={styles.tooltipWrapper}>
            <span>date: {createdAt}</span>
            <span>proposals: {FormatUtils.formatNumberWithCommas(Number(proposals), 0)}</span>
        </div>
    );
};
